export * from './ModalTemplate'
export * from './ModalTemplate.props'